module.exports = "<mat-card>\n  <p>User statistics</p>\n  <span>Coming soon ...</span>\n</mat-card>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/components/info/info.component.html
// module id = ./src/app/modules/users/components/info/info.component.html
// module chunks = main